import { clsx } from 'clsx';

import FieldWrapper from '../FormFieldWrapper';
import styles from './TextField.module.css';

import type { TextFieldProps } from './TextField.types';
import type { Path } from 'react-hook-form';
import type { ControllerRenderProps, ControllerFieldState } from 'react-hook-form';

export function TextField<T extends Record<string, unknown>>({
  autocomplete,
  label,
  labelVariant = 'regular',
  name,
  placeholder,
  rules,
  suffix,
  type = 'text',
  size = 'md',
}: TextFieldProps<T>) {
  return (
    <FieldWrapper<T> name={name} label={label} rules={rules} labelVariant={labelVariant}>
      {({ value, ...rest }: ControllerRenderProps<T, Path<T>>, fieldState: ControllerFieldState) => {
        const errorId = `${String(name)}-error`;
        const input = (
          <input
            {...rest}
            id={String(name)}
            type={type}
            placeholder={placeholder}
            autoComplete={autocomplete}
            className={clsx(styles.textField, suffix && styles.hasSuffix, styles[size])}
            aria-invalid={fieldState.invalid ? 'true' : undefined}
            aria-describedby={fieldState.error ? errorId : undefined}
            value={(value ?? '') as string | number | readonly string[]}
          />
        );

        if (!suffix) return input;

        return (
          <div className={styles.inputContainer}>
            {input}
            <div className={styles.suffix}>{suffix}</div>
          </div>
        );
      }}
    </FieldWrapper>
  );
}

TextField.displayName = 'TextField';
